<template>
    <div class="step_three_pb">
        <v-row align="center" class="my-10 my-sm-15">
            <v-col cols="12" style="position: relative;">
                <div>
                    <h1 :style="{ backgroundImage: 'url(' + homes_jigu + ')' }" class="title-line"></h1>
                    <img :src="homes_step3" class="title-img px-3 px-sm-8">
                </div>
            </v-col>
        </v-row>
        <v-row class="mt-2">
            <v-col cols="12 pt-0 pb-2 pb-md-1"><h5 class="subtitle">使いたい画像をアップロードしよう！</h5></v-col>
        </v-row>
        <v-row style="margin-top: 18px;">
            <v-col cols="12" style="position: relative;">
                <label for="imgForm" class="custom-file-input-label pa-0"
                :class="{
                    'custom-file-input-label-selected': label !== 'アップロードする画像を選択',
                    'error-image-col': $store.state.error.image
                    }">
                    <p
                    class="custom-file-input-filename ma-0"
                    :class="{'custom-file-input-filename-notSelected': label === 'アップロードする画像を選択', }"
                    >{{label}}</p>
                    <input type="file"
                    id="imgForm"
                    class="custom-file-input"
                    accept="image/*"
                    @click="lightReset"
                    @change="onAddFiles">
                    <p
                    class="custom-file-input-delete ma-0"
                    :class="{'d-none': label === 'アップロードする画像を選択'}"
                    @click.stop.prevent="delteFile">アップロードした画像を削除</p>
                </label>
                <div class="error_dialog_base" :class="{'error_dialog_image': label !== 'アップロードする画像を選択'}">
                    <p class="ma-0 pa-0"
                    :class="{'d-none': !$store.state.error.image}"
                    style="font-size: 14px;">{{$store.state.error.image}}</p>
                </div>
            </v-col>
        </v-row>
        <div id="myModal" class="modal" v-show="modal">
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import plus from '../assets/plus.svg';
import minus from '../assets/minus.svg';
import icon_back from '../assets/icon_back.svg';
import {
        THEME1_HEIGHT,
        THEME1_WIDTH,
        THEME3_HEIGHT,
        THEME3_WIDTH,
        } from '../const';
import homes_jigu from '../assets/homes_jigu.svg';
import homes_step3 from '../assets/homes_step3.svg';
export default {
    props:[
      'imgForm',
    ],
    data(){
        return{
            rules: [
                value => !value || value.size < 10000000 || 'Avatar size should be less than 10 MB!',
            ],
            bound: {
                width: 660,
                height: 510,
            },
            vp: {
                width: 444,
                height: 444,
            },
            src: {
                url: "",
                name: "ee"
            },
            errorImage: "url of an image to use to indicate an error",
            cropped: null,
            label: "アップロードする画像を選択",
            modal: false,
            plus,
            minus,
            icon_back,
            homes_jigu,
            homes_step3
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
    },
    watch: {
    },
    methods: {
        ...mapActions(['updateImageAction', 'updateImageErrorAction']),
        updateImage(val){
            this.updateImageAction({
                image: val
            })
        },
        onAddFiles(){
            console.log("#");
        },
        crop() {
            let options = {
                format: 'jpeg',
                size: {
                    width:THEME1_WIDTH * 1.5,
                    height:THEME1_HEIGHT * 1.5
                },
                quality: 1
            }
            if (this.getTheme === 3){
                options.size = {
                    width: THEME3_WIDTH * 1.5,
                    height: THEME3_HEIGHT * 1.5
                }
            }
            this.$refs.croppieRef.result(options, (output) => {
                this.cropped = output;
                this.updateImage(this.cropped.slice(22));
                this.label = this.src.name;
            });
            this.modal = false;
        },
        lightReset(){
            this.imgForm.value = "";
        },
        delteFile(){
            this.imgForm.value = "";
            this.label = "アップロードする画像を選択";
            this.updateImage("");
        },
        back(){
            this.modal = false;
        },
        result(output) {
            this.cropped = output;
        }
    }
}
</script>

<style scoped>
.custom-file-input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    color: transparent;
}
.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}
.custom-file-input-label {
    position: relative;
    width: 100%;
    height: 54px;
    color: #ed6103;
    display: inline-block;
    background: white;
    border: 1px solid #707070;
    border-radius: 6px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    font-size: 14px;
    outline: none;
}
.custom-file-input:focus {
  outline-color: #1976d2;
}
.custom-file-input-filename{
    display: inline-block;
    padding: 16.5px 0 16.5px 25px;
    width: calc(100% - 250px);
    overflow: hidden;
    text-overflow: ellipsis;
}
.custom-file-input-filename-notSelected{
    padding: 16.5px 25px;
    width: 100%;
}
.custom-file-input-delete{
    display: flex;
	align-items: center;
    padding: 16.5px 25px 16.5px 0px;
    float: right;
}
.custom-file-input-delete::before{
    content: "";
    flex-grow: 1;
    height: 18px;
    width: 1px;
    background: #444;
    display: block;
    margin-right: 3em;
}
.step_three_pb{
    padding-bottom: 60px;
}
.error_dialog_base{
    margin: 0 0 8px;
    padding: 0 12px;
    position: absolute;
    background-color: white;
    color: #FF5252;
    width: Calc(100% - 24px);
    z-index: 1;
}
.error_dialog_image{
    transform: translate(0px, 0px);
}
.error-image-col{
    border-color: #FF5252;
}
@media only screen and (max-width: 959px){
    .custom-file-input-label-selected{
        height: 107px;
    }
    .custom-file-input-filename{
        width: 100%;
        padding: 16.5px 25px;
    }
    .custom-file-input-delete{
        display: block;
        padding: 0 25px 16.5px 25px;
        float: left;
        width: 100%;
    }
    .custom-file-input-delete::before{
        content: "";
        flex-grow: 1;
        height: 1px;
        width: 100%;
        background: #444;
        display: block;
        margin-top: -2px;
        margin-bottom: 16.5px;
    }
    .step_three_pb{
        padding-bottom: 40px;
    }
    .error_dialog_image{
        transform: translate(0px, 4px);
    }
}

.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  background-color: #fefefe;
  border: 1px solid #888;
  border-radius: 5px;
}
.croppie_tab{
    position: absolute;
}
.minus{
    transform: translate(130px, -47px);
    width: 30px;
}
.plus{
    transform: translate(460px, -47px);
    width: 30px;
}
@media only screen and (max-width: 599px){
    .minus{
        transform: translate(5px, -47px);
    }
    .plus{
        transform: translate(284px, -47px);
    }
}
</style>
